// extracted by mini-css-extract-plugin
export var carrierNotice = "_m6-5";
export var carrierNoticePlaceholder = "_m6-6";
export var deliveryRow = "_m6-c";
export var fixedHeight = "_m6-4";
export var freightLogo = "_m6-b";
export var fullWidth = "_m6-3";
export var priceColumn = "_m6-7";
export var radioSelected = "_m6-9";
export var radioUnselected = "_m6-8";
export var selectedOption = "_m6-2";
export var selectedOptionContainer = "_m6-1";
export var selection = "_m6-0";
export var tallSkeletonText = "_m6-a";